<template>
  <div
    @dragleave.prevent
    @dragover.prevent
    @drop.prevent
  >
    <Breadcrumbs
      :paths="['/file', $route.path]"
    ></Breadcrumbs>
    <v-toolbar>
      <v-toolbar-title>
        {{ $t("message.file.file_upload") }}
      </v-toolbar-title>
    </v-toolbar>
    <v-stepper v-model="step" vertical class="mt-1">
      <v-stepper-step :complete="step > 1" step="1">
        {{ $t("message.common.select_file") }}
      </v-stepper-step>
      <v-stepper-content step="1">
        <v-card>
          <Upload
            ref="upload"
            :type="file_type"
            :valid="files_valid"
            :multiple="true"
            :max_files="5"
            v-on:update_files_valid="files_valid = $event"
            v-on:done_upload="done_upload"
            :upload_detail="upload_detail_parm"
          >
          </Upload>
          <v-card-text>
            <v-select
              :label="$t('message.file.file_type')"
              :items="file_types"
              item-text="label"
              item-value="value"
              v-model="file_type"
              hide-details
              :disabled="!(file_types.length < 1)"
            >
              <template v-slot:item="props">
                {{ $t('message.file.file_type_' + props.item.label) }}
              </template>
              <template v-slot:selection="props">
                <v-list-item class="pa-2 pl-0" style="min-height:auto">
                  {{ $t('message.file.file_type_' + props.item.label) }}
                </v-list-item>
              </template>
            </v-select>
          </v-card-text>
        </v-card>
        <v-card flat class="pt-5">
          <p class="text-right">
            <v-btn
              color="primary"
              :disabled="files_valid || executing"
              @click="upload_file()"
            >
              {{ $t("message.common.upload") }}
            </v-btn>
            <v-btn :to="get_prev('file')">
              {{ $t("message.common.prev") }}
            </v-btn>
          </p>
        </v-card>
      </v-stepper-content>

      <v-stepper-step step="2">
        {{ $t("message.common.complete") }}
      </v-stepper-step>
      <v-stepper-content step="2">
        <v-card>
          <v-card-text>
            {{ $t("message.common.upload_success") }}
            <template v-if="$refs.upload">
              <v-list v-for="file in $refs.upload.uploading_files" :key="file.file_name">
                <v-list-item dense :to="file.fid">
                  <v-list-item-icon>
                    <v-icon>
                      mdi-link-variant
                    </v-icon>
                  </v-list-item-icon>
                  <v-list-item-title>
                    {{ file.file_name }}:&nbsp;{{ file.fid }}
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </template>
          </v-card-text>
        </v-card>
        <v-card flat class="pt-5">
          <p class="text-right">
            <v-btn :to="get_prev('file')">
              {{ $t("message.common.prev") }}
            </v-btn>
          </p>
        </v-card>
      </v-stepper-content>
    </v-stepper>
  </div>
</template>

<script>
import Breadcrumbs from '../components/Breadcrumbs';
import Upload from '../components/Upload';

export default {
  name: 'file_upload',
  components: {
    Breadcrumbs,
    Upload
  },
  data: function(){
    return {
      module_id: "24",
      step: 1,
      executing: false,
      files_valid: true,
      file_type: "source",
      file_types: [
        {
          "label": "source",
          "value": "source"
        }/*,
        {
          "label": "user",
          "value": "user"
        }*/
      ],
      upload_detail_parm:{
        target: 'source',
        additional: true,
        size: 300,
        count: 200000,
        files: 1
      }
    }
  },
  methods: {
    upload_file: function(){
      this.executing = true;
      this.$refs.upload.upload();
    },
    done_upload: function(success){
      if(success){
        this.step = 2;
      }else{
        this.$router.push("/file");
      }
    },
    get_prev: function(module){
      var prev = "/" + module;
      if(this.$route.query.referer){
        var referers = this.$route.query.referer.split(":");
        prev = referers.pop();
        if(referers.length > 0){
          prev += "?referer=" + encodeURIComponent(referers.join(":"));
        }
      }
      return prev;
    },
  }
}
</script>
